export * from './SimpleModalButton.types';
export { default as SimpleModalButton } from './SimpleModalButton';
